import { gql } from '@apollo/client';
import apolloClientAdapter from '@segurodeceso/core/adapters/apolloClient.adapter';
import { PlanT } from '@segurodeceso/core/domain/plans';

const GET_PLANS = gql`
  query GetAllPlans {
    getAllPlans {
      __typename
      ... on PlansT {
        plans {
          productCode
          planId
          planCode
          planName
          sponsor
          currency
          dependants
          prices {
            price
            priceWithDiscount
          }
          coverages {
            type
            amount
            currency
          }
        }
      }
      ... on DBErrorT {
        message
      }
      ... on ValidationErrorT {
        message
      }
      ... on ServiceErrorT {
        message
      }
    }
  }
`;

type GetPlansResponseT = {
  getAllPlans: {
    __typename: string;
    message?: string;
    plans?: PlanT[];
  };
};

const getPlans = async (signal: AbortSignal) => {
  try {
    const { getAllPlans } = await apolloClientAdapter<GetPlansResponseT>(
      process.env.FEDERATION_GATEWAY || ''
    )(GET_PLANS, {
      context: {
        fetchOptions: {
          signal,
        },
      },
    });

    switch (getAllPlans.__typename) {
      case 'PlansT':
        return getAllPlans.plans;
      case 'DBErrorT':
        throw new Error(getAllPlans.message);
      case 'ValidationErrorT':
        throw new Error(getAllPlans.message);
      case 'ServiceErrorT':
        throw new Error(getAllPlans.message);
      default:
        throw new Error('Unknown error occurred');
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request was cancelled');
    } else {
      throw error;
    }
  }
};

export default getPlans;
